import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import logo from '../Assets/Images/UXI-Logo.png';

function CompAppHeader() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const menuItems = [
    { text: 'Home', link: '/' },
    { text: 'About', link: '/about' },
    { text: 'Startups and Products', link: '/startups-and-products' },
    { text: 'UX-as-a-Service', link: '/ux-as-a-service' },
    { text: 'CX Main Street', link: '/cx-main-street' },
    { text: 'Contact', link: '/contact' },
  ];

  return (
    <AppBar position="static" style={{ backgroundColor: 'transparent', borderBottom: '1px solid white' }}>
      <Toolbar>
        <img src={logo} alt="logo" style={{ marginRight: '20px', height: '40px' }} />
        <Typography variant="h6" style={{ flexGrow: 1 }}></Typography>
        <Box display={{ xs: 'none', md: 'flex' }} style={{ marginLeft: 'auto' }}>
          {menuItems.map((item) => (
            <Link
              key={item.text}
              component={RouterLink}
              to={item.link}
              color="inherit"
              style={{ margin: '0 10px', textDecoration: 'none', fontFamily: 'Roboto', fontWeight: 400 }}
            >
              {item.text}
            </Link>
          ))}
        </Box>
        <Box display={{ xs: 'flex', md: 'none' }}>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List>
          {menuItems.map((item) => (
            <ListItem button key={item.text} component={RouterLink} to={item.link} onClick={toggleDrawer(false)}>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}

export default CompAppHeader;
